import styled from "styled-components";


export const StyledFilterSelectedWrapper = styled.div`
    display: grid;
    gap: 1rem;
    justify-content: center;
    text-align: center;
    grid-template-columns: 100%;

    @media (min-width: 992px) {
        grid-template-columns: auto 2fr auto;
        align-items: center;
        justify-content: space-between;
    }
`

export const StyledCountProducts = styled.div`
    font-weight: 400;
    font-size: clamp(14px, 2vw, 18px);
    line-height: 120%;
    letter-spacing: 0%;
    color: ${(props) => props.theme.colors.textSecondary};

`


